
import { createDraftSafeSelector, Reducer, SliceCaseReducers } from "@reduxjs/toolkit";
import { RootState } from "../../../Store";
import { AnimalEvent } from "../AnimalDataCalls/GQLCalls/getAnimalCall";
import { createAsyncEntitySlice } from "../../../Store/Entities/createAsyncEntitySlice";
import { AsyncEntityState } from "../../../Store/Thunks/asyncEntityStateUtil";
import { fetchEventsByAnimalIdsThunk } from "../../../Store/Thunks/eventsByAnimalIds";
import { EnqueueFetcher } from "../../../Store/Thunks/enqueueFetcher";

export interface AnimalEventInfo extends AnimalEvent {
  animal_id: number;
}

const {reducer, actions, entityAdapter: eventDataAdapter} = createAsyncEntitySlice<AnimalEventInfo,number,SliceCaseReducers<AsyncEntityState<AnimalEventInfo,number>>, AnimalEventInfo>({
  name: "events",
  reducers: {},
  fetchByIdsThunk: fetchEventsByAnimalIdsThunk,
  selectId: (event: AnimalEventInfo) => event.eventNo
}) 

const stateSelector = (state:RootState) => state.graphQlData.events;

export const eventReducer = reducer as Reducer<AsyncEntityState<AnimalEventInfo, number>>;
export const { addMany: addEvent, updateOne: updateEvents, updateMany: updateManyEvents, removeAll: clearEvents, upsertMany: upsertEvents, clearPendingIds, addPendingId, addLoadingIds } = actions;
export const { selectById: selectEventById, selectAll: selectAllEvents } = eventDataAdapter.getSelectors(stateSelector);

export const selectEventByAnimal = createDraftSafeSelector(selectAllEvents, (_, animal_id: number) => animal_id, (events: AnimalEventInfo[], animal_id: number) => events.filter((event) => event.animal_id === animal_id));

const eventFetch = new EnqueueFetcher(fetchEventsByAnimalIdsThunk, stateSelector, clearPendingIds, addPendingId, addLoadingIds);

export const dispatchFetchAnimalEvent = eventFetch.enqueueFetchById;